<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<div id="yjLeftTop" style="width:100%;height:100%;"></div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: [],
				myChart: ''
			}
		},
		mounted() {
			this.$request('/center/home/rightOne').then(res => {
				this.init(res.data.list);
			})
		},
		methods: {
			init(pageData) {
				let that = this
				this.myChart = echarts.init(document.getElementById("yjLeftTop"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				var option = {
					tooltip: {
						trigger: 'item',
					},
					legend: {
						show: false,
					},
					// 圆环中心区域
					graphic: [{
							// 第一行文字
							type: 'text',
							left: 'center',
							top: '35%',
							style: {
								text: 74,
								fontSize: 18,
								fill: 'rgba(255, 246, 0, 1)',
							},
						},
						// {
						// 	// 第二行文字
						// 	type: 'text',
						// 	left: 'center',
						// 	top: '50%',
						// 	style: {
						// 		text: '总数',
						// 		fontSize: 14,
						// 	},
						// },
					],
					series: [{
						name: '',
						type: 'pie',
						radius: ['60%', '85%'],
						avoidLabelOverlap: false,
						label: {
							show: false,
						},
						emphasis: {
							label: {
								show: false,
							},
						},
						labelLine: {
							show: false,
						},
						data: [{
								value: 74,
								name: '正常状态',
								itemStyle: {
									color: '#50dfb2'
								}
							},
							{
								value: 26,
								name: '异常状态',
								itemStyle: {
									color: '#f7b500'
								}
							},
							// {
							// 	value: 30,
							// 	name: '分类_3',
							// 	itemStyle: {
							// 		color: '#5b76f9'
							// 	}
							// },
						],
					}, ],
				};

				this.myChart.setOption(option);

				setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 15000)
			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>